import { render, staticRenderFns } from "./ProductionRawMaterialItem.vue?vue&type=template&id=16faf0f0&"
import script from "./ProductionRawMaterialItem.vue?vue&type=script&lang=js&"
export * from "./ProductionRawMaterialItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductionRawMaterialItem.vue"
export default component.exports